export default __webpack_public_path__ + "static/media/WelcomePageStep2.b96a43d7.png";